import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import classNames from 'classnames'
import GridList, {GridListTile} from 'material-ui/GridList'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import {CircularProgress} from 'material-ui/Progress'
import IconKeyboardArrowLeft from 'material-ui-icons/KeyboardArrowLeft'
import IconKeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight'

import {pickup as text} from '../text'
import moment from '../../../common/moment'
import LoadingButton from '../../../common/components/LoadingButton'

import {pickup as styles} from '../styles'

class Pickup extends React.Component {

  constructor(props) {
    super(props)

    const dates = this.buildDates()
    this.state = {
      dates: dates,
      node: null,
    }
  }

  handleSelectDate = (selected) => {
    this.props.selectDate(selected)
  }

  handleSelectTimeslot = (selected) => {
    this.props.selectTimeslot(selected)
  }

  buildDates = () => {
    moment.locale('es')
    let today = new Date()
    const dates = []
    for (let i = 0; i < 90; i++) {
      const date = new Date()
      date.setDate(today.getDate() + i)
      dates.push(moment(date))
    }
    return dates
  }

  render() {
    const {
      classes, isFetchingDates, unavailableDates, dateSelected, timeslots, timeslotSelected, isFetchingTimeslots,
      address, isButtonDisabled, isButtonLoading,
    } = this.props
    return (
      <div>
        <Title
          classes={classes}
          address={address}
          onClick={() => this.props.setStep(3)}
        />
        <Dates
          classes={classes}
          isFetching={isFetchingDates}
          dates={this.state.dates}
          handleSelectDate={this.handleSelectDate}
          dateSelected={dateSelected}
          unavailableDates={unavailableDates}
          handleArrowClick={this.handleArrowClick}
        />
        <Month
          classes={classes}
          isFetching={isFetchingDates}
          dateSelected={dateSelected}
        />
        <Slots
          classes={classes}
          isFetching={isFetchingTimeslots}
          slots={timeslots}
          handleSelectTimeslot={this.handleSelectTimeslot}
          timeslotSelected={timeslotSelected}
        />
        <Actions
          classes={classes}
          onClick={this.props.modifyTransaction}
          isLoading={isButtonLoading}
          isDisabled={isButtonDisabled}
        />
      </div>
    )
  }

  static propTypes = {
    dateSelected: PropTypes.object,
    unavailableDates: PropTypes.array,
    selectDate: PropTypes.func.isRequired,
    timeslots: PropTypes.array,
    timeslotSelected: PropTypes.number,
    selectTimeslot: PropTypes.func.isRequired,
    setStep: PropTypes.func.isRequired,
    isFetchingDates: PropTypes.bool,
    isFetchingTimeslots: PropTypes.bool,
    error: PropTypes.string,
    address: PropTypes.string,
    modifyTransaction: PropTypes.func,
    isButtonLoading: PropTypes.bool,
    isButtonDisabled: PropTypes.bool,
  }
}

const Title = ({classes, address, onClick}) => (
  <div>
    <Typography variant="title" className={classes.dialogTitle}>{text.whenDoWePickItUp} {address ? address : '...'}?</Typography>
    <Typography className={classes.changeAddress} onClick={onClick}>{text.changeAddress}</Typography>
  </div>
)

class Ul extends React.Component {

  styles = {
    container: {
      position: 'relative',
      width: 'calc(100% - 60px)',
      margin: '0 auto',
    },
    arrowLeft: {
      position: 'absolute',
      left: -30,
      top: 13,
      height: 35,
      width: 35,
      padding: 5,
    },
    arrowRight: {
      position: 'absolute',
      right: -30,
      top: 13,
      height: 35,
      width: 35,
      padding: 5,
    },
  }

  el = {}

  handleArrowClick = dir => {
    if (this.el) this.el.scrollLeft = this.el.scrollLeft + 150 * dir
  }

  componentWillReceiveProps(props) {
    if (this.el) this.centerOnDate(props.indexSelected)
  }

  centerOnDate = indexSelected => {
    if (indexSelected && indexSelected !== -1) {
      this.el.scrollLeft = 50 * indexSelected - 100
    }
  }

  render() {
    const {children, indexSelected, ...other} = this.props //indexSelected triggers a DOM error in ul
    return (
      <div style={this.styles.container}>
        <IconButton style={this.styles.arrowLeft} onClick={() => this.handleArrowClick(-1)}>
          <IconKeyboardArrowLeft/>
        </IconButton>
        <ul {...other} ref={input => { this.el = input }}>{children}</ul>
        <IconButton style={this.styles.arrowRight} onClick={() => this.handleArrowClick(1)}>
          <IconKeyboardArrowRight/>
        </IconButton>
      </div>
    )
  }
}

const Dates = ({classes, isFetching, dates, handleSelectDate, dateSelected, unavailableDates}) => (
  <div className={classes.dateListContainer}>
    {
      isFetching === true ? <LoadingBackdrop classes={classes}/> : null
    }
    <GridList
      cols={0}
      cellHeight={50}
      className={classes.dateList}
      component={Ul}
      indexSelected={dates.findIndex(d => compareDates(d, dateSelected))}
    >
      {dates.map((d, key) => (
        <GridListTile key={key} className={classes.listTile} onClick={() => handleSelectDate(d)}>
          <div className={classes.dayOfWeek}>{d.format('ddd').substr(0, 3).toUpperCase()}</div>
          <IconButton
            className={classNames(classes.date, {[classes.dateSelected]: compareDates(d, dateSelected)})}
            disabled={findDate(d, unavailableDates)}
          >
            {d.date()}
          </IconButton>
        </GridListTile>
      ))}
    </GridList>
  </div>
)

const Month = ({classes, dateSelected}) => (
  <div>
    <Typography variant="title" align="center" gutterBottom className={classes.month}>
      {dateSelected ? dateSelected.format('MMMM').toUpperCase() : null}
    </Typography>
  </div>
)

const Slots = ({classes, isFetching, slots, handleSelectTimeslot, timeslotSelected}) => (
  <div className={classes.slotsContainer}>
    {
      isFetching === true ? <LoadingBackdrop classes={classes}/> : null
    }
    <GridList cols={3} cellHeight={33}>
      {slots.map((t, key) => (
        <GridListTile
          key={key}
          className={classes.timeslotTile}
          onClick={() => handleSelectTimeslot(t.get('ID'))}
        >
          <Button
            size="small"
            variant={t.get('ID') === timeslotSelected ? 'raised' : 'flat'}
            color={t.get('ID') === timeslotSelected ? 'primary' : 'inherit'}
            className={classes.timeslotTileButton}
          >
            {t.get('Hour') + ':' + pad(t.get('Minute'))}
          </Button>
        </GridListTile>
      ))}
    </GridList>
  </div>
)

const Actions = ({classes, onClick, isDisabled, isLoading}) => (
  <div className={classes.dialogActions}>
    <LoadingButton
      variant="raised"
      color="primary"
      onClick={onClick}
      disabled={isDisabled}
      isLoading={isLoading}
    >
      {text.continue}
    </LoadingButton>
    <Typography className={classes.viewPrices}>{text.viewPrices}</Typography>
  </div>
)

const LoadingBackdrop = ({classes}) => {
  return (
    <div className={classes.loadingContainer}>
      <CircularProgress
        size={24}
        className={classes.progress}
      />
    </div>
  )
}

function pad(string) {
  const str = '' + string
  const pad = '00'
  return pad.substring(0, pad.length - str.length) + str
}

function findDate(date, dates) {
  for (let i = 0; i < dates.length; i++) {
    if (compareDates(date, dates[i])) return true
  }
  return false
}

function compareDates(a, b) {
  if (!a || !b) return false
  //only interested in comparing year, month and date
  return a.format('YYYYMMDD') === b.format('YYYYMMDD')
}

export default withStyles(styles, {withTheme: true})(Pickup)



// WEBPACK FOOTER //
// ./src/sections/rent/components/pickup.jsx